import * as React from 'react'
import { FastField } from 'formik'

import { BestContactMethodSelect } from '@user/components/Formik/BestContactMethodSelect/BestContactMethodSelect'
import { BestContactTimeSelect } from '@user/components/Formik/BestContactTimeSelect/BestContactTimeSelect'
import { MuiMobileDatePickerFormik } from '@user/components/Formik/MuiMobileDatePickerFormik'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'

import type { LeadExtraFieldKey } from './utils/mapMissingFieldsToForm'

interface Props {
  fieldKey: LeadExtraFieldKey
}

/** Renders one lead-only required field the shared Pending Lead renderers do not cover. */
export function LeadCompanyRequiredField(props: Props) {
  const { fieldKey } = props
  const tidalThemeActive = useTidalThemeActive()
  const density = tidalThemeActive ? 'normal' : 'compact'

  switch (fieldKey) {
    case 'preferredMethodOfContact':
      return (
        <BestContactMethodSelect
          name="preferredMethodOfContact"
          density={density}
          required
          show
        />
      )
    case 'preferredTimeOfContact':
      return (
        <BestContactTimeSelect
          name="preferredTimeOfContact"
          density={density}
          required
          show
          showCheckBox
        />
      )
    case 'nextActionDate':
      return (
        <FastField
          name="nextActionDate"
          label="Next Action Date"
          component={MuiMobileDatePickerFormik}
          disablePast
          clearable
          fullWidth
          required
        />
      )
    default:
      return null
  }
}
LeadCompanyRequiredField.displayName = 'LeadCompanyRequiredField'
